 // src/api/axiosInstance.js
import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "");

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
});

// Load token ONLY from localStorage or window
function getToken() {
  return (
    window.__APP_AUTH__?.token ||
    localStorage.getItem("authToken") ||
    null
  );
}

// ===========================
// REQUEST INTERCEPTOR
// ===========================
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ===========================
// RESPONSE INTERCEPTOR
// ===========================
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = (
      error.response?.data?.message || ""
    ).toLowerCase();

    // Logout ONLY for unauthorized responses.
    // A 403 can mean trial limit reached or permission denied.
    // Neither should automatically log out the user.
    if (status === 401) {
      // Login blocked / session replaced / session expired
      if (
        message.includes("already logged in") ||
        message.includes("another device") ||
        message.includes("logged in elsewhere") ||
        message.includes("session expired")
      ) {
        alert(
          "Your session ended. This account may be used on another device or your session expired."
        );
      }

      // Clear authentication only for 401
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");

      window.__APP_AUTH__ = {};

      // Redirect to login
      window.location.replace("/login");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
